/**
*   配置文件
*/

const CNF = {
    'api': process.env.REACT_APP_API,
    'onaiApi': process.env.REACT_APP_ONAI_API,
    'ossApi': process.env.REACT_APP_OSS_API,
    'projectCode': 'CHAT',
    'projectName': 'XinYuanChat',
    'projectFullname': 'XinYuanChat',       // 项目全称
    'version': '2.1.1',
    'mainUrl': '',                                // 主页地址
    'homeUrl': process.env.REACT_APP_HOME_URL,    // 首页地址
    'loginUrl': process.env.REACT_APP_LOGIN_URL,  // 登录地址
    'userUrl': process.env.REACT_APP_USER_URL,    // 设置地址
    'companyShortName': '新致腾',                   //  公司简称
    'locale': 'zhCN',                             // antd国际化语言
    'bassicColor': '#001529',                     // 基础颜色
    'safetyColor': '#308014',                     // 安全颜色
    'warningColor': '#FAAD13',                    // 警告颜色
    'dangerColor': '#FF0000',                     // 危险颜色

    'themeColors': [    //可选主题颜色
        '#fa541c',
        '#1677ff',
        '#13c2c2',
        '#722ed1',
        '#fa8c16',
        '#f5222d',
        '#52c41a',
        '#eb2f96',
        '#a0d911',
        '#faad14',
    ],
    'isDisplayTableBorder': 0,                         // 是否显示表格边框
    'cookies': {
        'keySecure': true,
        'keyPath': '/',
        'keyDomain': process.env.REACT_APP_COOKIE_DOMAIN,
        'keyExpire': 2592000,
        'keyUid': 'login_xzt_uid',
        'keyId': 'login_xzt_id',
        'keyToken': 'login_xzt_token',
        'keyUsername': 'login_xzt_username',
        'keyDisplayname': 'login_xzt_displayname',
        'keyAvatarUrl': 'login_xzt_avatar_url',
        'keyThemeColor': 'login_xzt_theme_color',
        'keyIsDisplayTableBorder': 'login_xzt_is_display_table_border',
    },
    'timeout': 5000,
    'tDivisor': 9999999999,
    'maxAge': 3600,
    'fontSize': 14,                          // 字体大小
    'menuHeight': '44px',
    'menuLineHeight': '40px',
    'messageDuration': 1.5,                  // 消息弹框持续时间，单位秒
    'animateDuration': 2000,                 // 动画持续时间，单位秒
    'screenWidth': 1440,                     // 系统屏幕宽度
    'searchMarginLeft': 5,                   // 搜索栏左边距
    'rowMarginTop': 10,                      // 行距顶部高度
    'lineHeight': 2.2,                       // 行高
    'tableOperationColumnWidth': 80,         // 表格操作者列宽度
    'tableStatusColumnWidth': 80,            // 表格状态列宽度
    'tableCreateTimeColumnWidth': 120,       // 表格创建时间列宽度
    'tableCreateDisplayeColumnWidth': 90,    // 表格创建者列宽度
    'maxPageSize': 65535,                    //  最大分页数，主要用于下拉列表
    'pageSize': 10,
    'DPL': 2,                                // 小数点长度（Decimal Point Length）
    'swatches': {   // 色板
        'default': ['#1983FF', '#07C9CA', '#F0884D', '#D580FF', '#7963FF', '#BD8F25', '#60C42E', '#FF80CA', '#2492B3', '#18C86F'],
    },
    'currentSwatche': 'default', // 当前色板
    // 'xinyuanModel': 'deepseek',                   //  AI模型
    // 'xinyuanVersionId': 'deepseek-chat',          //  AI模型版本
    'xinyuanModel': 'moonshot',                     //  AI模型
    'xinyuanVersionId': 'moonshot-v1-auto',          //  AI模型版本
    'xinyuanStream': 1,                            //   AI模型流式输出
    'services': [
        { 'key': '账户', 'value': 'seal', 'id': 1 },
        { 'key': '项目', 'value': 'plms', 'id': 2 },
        // { 'key': '交通', 'value': 'teii', 'id': 3 },
        // { 'key': '资产', 'value': 'asms', 'id': 4 },
        // { 'key': '云盾', 'value': 'csss', 'id': 5 },
        { 'key': '云网盘', 'value': 'cfms', 'id': 6 },
        { 'key': '供应链', 'value': 'scms', 'id': 7 },
    ],
    'status': [
        { 'key': '激活', 'value': '激活' },
        { 'key': '禁用', 'value': '禁用' },
    ],
    'navItems': [
        {
            'url': '/admin/quotas', 'icon': 'setting', 'm': 1, 'name': '配额管理', 'ptn': 'btn_chat_quota', 'sub': 'sub1', 'submenu': [
                { 'url': '/admin/quota/tokens', 'name': '令牌配额管理', 'icon': '', 'm': 11, 'ptn': 'btn_chat_quota_token', 'isLogModule': true },
                { 'url': '/admin/quota/images', 'name': '图片配额管理', 'icon': '', 'm': 12, 'ptn': 'btn_chat_quota_image', 'isLogModule': true },
            ]
        },
        {
            'url': '/admin/commands', 'icon': 'setting', 'm': 2, 'name': '指令管理', 'ptn': 'btn_chat_command', 'sub': 'sub2', 'submenu': [
                { 'url': '/admin/command/publics', 'name': '指令仓库管理', 'icon': '', 'm': 21, 'ptn': 'btn_chat_command_public', 'isLogModule': true },
                { 'url': '/admin/command/keywords', 'name': '指令词语管理', 'icon': '', 'm': 22, 'ptn': 'btn_chat_command_keyword', 'isLogModule': true },
            ]
        },
        {
            'url': '/admin/reports', 'icon': 'message', 'm': 3, 'name': '统计报表', 'ptn': 'btn_chat_report', 'sub': 'sub3', 'submenu': [
                { 'url': '/admin/report/log/ttcd', 'name': '每日接口用量统计', 'icon': '', 'm': 31, 'ptn': 'btn_chat_report_log_ttcd' },
                { 'url': '/admin/report/log/trcd', 'name': '每日接口调用统计', 'icon': '', 'm': 32, 'ptn': 'btn_chat_report_log_trcd' },
                { 'url': '/admin/report/log/dmc', 'name': '接口模型分类占比', 'icon': '', 'm': 33, 'ptn': 'btn_chat_report_log_dmc' },
                { 'url': '/admin/report/quota/rqtc', 'name': '用户配额用量排名', 'icon': '', 'm': 34, 'ptn': 'btn_chat_report_quota_rqtc' },
            ]
        },
        {
            'url': '/admin/log/operations', 'icon': '', 'm': 4, 'name': '日志管理', 'ptn': 'btn_chat_log', 'sub': 'sub4', 'submenu': [
                { 'url': '/admin/log/operations', 'name': '操作日志管理', 'icon': '', 'm': 41, 'ptn': 'btn_chat_log_operation' },
                { 'url': '/admin/log/apis', 'name': '接口日志管理', 'icon': '', 'm': 42, 'ptn': 'btn_chat_log_api' },
                { 'url': '/admin/log/models', 'name': '模型日志管理', 'icon': '', 'm': 43, 'ptn': 'btn_chat_log_model' },
            ]
        }
    ],
    'actionName': { // 动作名称
        'CREATE': '新增',
        'UPDATE': '修改',
        'ACTIVE': '激活',
        'DISABLE': '禁用',
        'DELETE': '删除',
        'EXPORT': '导出',
    },
    'models': [
        {
            'key': '月之暗面·moonshot', 'value': 'moonshot', 'logo': 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/logo-kimi.png',
            versions: [
                { 'key': 'moonshot-v1-auto', 'value': 'moonshot-v1-auto', temperature: 0.3, top_p: 1.0, max_tokens: 8, },
                { 'key': 'moonshot-v1-8k', 'value': 'moonshot-v1-8k', temperature: 0.3, top_p: 1.0, max_tokens: 8, },
                { 'key': 'moonshot-v1-32k', 'value': 'moonshot-v1-32k', temperature: 0.3, top_p: 1.0, max_tokens: 32, },
                { 'key': 'moonshot-v1-128k', 'value': 'moonshot-v1-128k', temperature: 0.3, top_p: 1.0, max_tokens: 128, },
                { 'key': 'kimi-latest', 'value': 'kimi-latest', temperature: 0.3, top_p: 1.0, max_tokens: 8, },
                { 'key': 'kimi-k2-thinking', 'value': 'kimi-k2-thinking', temperature: 0.3, top_p: 1.0, max_tokens: 256, },
                { 'key': 'kimi-k2-thinking-turbo', 'value': 'kimi-k2-thinking-turbo', temperature: 0.3, top_p: 1.0, max_tokens: 256, },
                { 'key': 'kimi-k2-turbo-preview', 'value': 'kimi-k2-turbo-preview', temperature: 0.3, top_p: 1.0, max_tokens: 256, },
            ],
            'prompt': 'Hi，我是 Moonshot～。作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。',
        },
        {
            'key': '深度求索·deepseek', 'value': 'deepseek', 'logo': 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/deepseek.png',
            versions: [
                { 'key': 'deepseek-v4-flash', 'value': 'deepseek-v4-flash', temperature: 1.3, top_p: 0.7, max_tokens: 384, },
                { 'key': 'deepseek-v4-pro', 'value': 'deepseek-v4-pro', temperature: 1.3, top_p: 0.7, max_tokens: 384, },
                { 'key': 'deepseek-chat', 'value': 'deepseek-chat', temperature: 1.3, top_p: 0.7, max_tokens: 4, },
                { 'key': 'deepseek-reasoner', 'value': 'deepseek-reasoner', temperature: 1.3, top_p: 0.7, max_tokens: 4, },
            ],
            'prompt': '你好，我是deepseek。作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。',
        },
        {
            'key': '阿里·通义千问', 'value': '通义千问', 'logo': 'https://juhecdn.oss-cn-hangzhou.aliyuncs.com/chat/logo-tongyi@2x.png',
            versions: [
                { 'key': 'qwen-turbo', 'value': 'qwen-turbo', temperature: 0.8, top_p: 0.8, max_tokens: 16, },
                { 'key': 'qwen-plus', 'value': 'qwen-plus', temperature: 0.8, top_p: 0.8, max_tokens: 32, },
                { 'key': 'qwen-max', 'value': 'qwen-max', temperature: 0.8, top_p: 0.8, max_tokens: 8, },
                { 'key': 'qwen3-max', 'value': 'qwen3-max', temperature: 0.8, top_p: 0.8, max_tokens: 64, },
                { 'key': 'qwen-flash', 'value': 'qwen-flash', temperature: 0.8, top_p: 0.8, max_tokens: 32, },
                // { 'key': 'qwen-coder', 'value': 'qwen-coder', temperature: 0.8, top_p: 0.8, max_tokens: 96, },
            ],
            'prompt': '你好，我是通义千问！我能理解人类语言、生成内容，是你生活和工作的智能助手。',
        },
        {
            'key': '字节跳动·豆包', 'value': '豆包', 'logo': 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/doubao.png',
            versions: [
                { 'key': 'doubao-1.5-pro-32k', 'value': 'doubao-1.5-pro-32k-250115', temperature: 1, top_p: 0.7, max_tokens: 12, },
                { 'key': 'doubao-1.5-pro-256k', 'value': 'doubao-1.5-pro-256k-250115', temperature: 1, top_p: 0.7, max_tokens: 12, },
                { 'key': 'doubao-1.5-lite-32k', 'value': 'doubao-1.5-lite-32k-250115', temperature: 1, top_p: 0.7, max_tokens: 12, },
            ],
            'prompt': '嗨，我是你的新朋友豆包！初次见面很开心。我呢，可以回答你的各种问题，给你工作学习上提供帮助，还能随时陪你聊天。嗯，你想问点什么呢？',
        },
        {
            'key': '百度·文心一言', 'value': '文心一言', 'logo': 'https://juhecdn.oss-cn-hangzhou.aliyuncs.com/chat/logo-wenxin@2x.png',
            versions: [
                { 'key': 'ERNIE 4.5 Turbo', 'value': 'ernie-4.5-turbo-128k', temperature: 1.0, top_p: 1.0, max_tokens: 2, },
                { 'key': 'ERNIE-Speed-8K', 'value': 'ERNIE-Speed-8K', temperature: 0.95, top_p: 0.7, max_tokens: 2, },
                { 'key': 'ERNIE-Speed-128K', 'value': 'ERNIE-Speed-128K', temperature: 0.95, top_p: 0.7, max_tokens: 4, },
                { 'key': 'ERNIE-Speed-Pro-128K', 'value': 'ERNIE-Speed-Pro-128K', temperature: 0.95, top_p: 0.7, max_tokens: 4, },
                { 'key': 'ERNIE-3.5', 'value': 'ERNIE-3.5-8K', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
                { 'key': 'ERNIE-4.0', 'value': 'ERNIE-4.0-8K', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
                { 'key': 'ERNIE-4.0-8K-Latest', 'value': 'ERNIE-4.0-8K-Latest', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
                { 'key': 'ERNIE-4.0-Turbo', 'value': 'ERNIE-4.0-Turbo-8K', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
                { 'key': 'ERNIE-4.0-Turbo-8K-Latest', 'value': 'ERNIE-4.0-Turbo-8K-Latest', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
                { 'key': 'ERNIE-4.0-Turbo-128K', 'value': 'ERNIE-4.0-Turbo-128K', temperature: 0.8, top_p: 0.8, max_tokens: 4, },
                { 'key': 'ERNIE-Lite-8K', 'value': 'ERNIE-Lite-8K', temperature: 0.95, top_p: 0.7, max_tokens: 2, },
                { 'key': 'ERNIE-Lite-Pro-128K', 'value': 'ERNIE-Lite-Pro-128K', temperature: 0.95, top_p: 0.7, max_tokens: 4, },
                { 'key': 'ERNIE-Tiny-8K', 'value': 'ERNIE-Tiny-8K', temperature: 0.95, top_p: 0.7, max_tokens: 2, },
                { 'key': 'ERNIE-Novel-8K', 'value': 'ERNIE-Novel-8K', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
            ],
            'prompt': '你好，我是文心一言。作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。',
        },
        {
            'key': '腾讯·混元', 'value': '混元', 'logo': 'https://juhecdn.oss-cn-hangzhou.aliyuncs.com/chat/logo-hunyuan@2x.png',
            versions: [
                { 'key': 'hunyuan-turbos-latest', 'value': 'hunyuan-turbos-latest', temperature: 1.0, top_p: 1.0, max_tokens: 8, },
                { 'key': 'hunyuan-t1-latest', 'value': 'hunyuan-t1-latest', temperature: 1.0, top_p: 1.0, max_tokens: 8, },
                { 'key': 'hunyuan-turbos-20250313', 'value': 'hunyuan-turbos-20250313', temperature: 1.0, top_p: 1.0, max_tokens: 8, },
                { 'key': 'hunyuan-turbos-20250226', 'value': 'hunyuan-turbos-20250226', temperature: 1.0, top_p: 1.0, max_tokens: 4, },
                { 'key': 'hunyuan-turbo-latest', 'value': 'hunyuan-turbo-latest', temperature: 1.0, top_p: 1.0, max_tokens: 4, },
                { 'key': 'hunyuan-turbo', 'value': 'hunyuan-turbo', temperature: 1.0, top_p: 1.0, max_tokens: 4, },
                { 'key': 'hunyuan-turbo-20241223', 'value': 'hunyuan-turbo-20241223', temperature: 1.0, top_p: 1.0, max_tokens: 4, },
                { 'key': 'hunyuan-large', 'value': 'hunyuan-large', temperature: 1.0, top_p: 1.0, max_tokens: 4, },
                { 'key': 'hunyuan-large-longcontext', 'value': 'hunyuan-large-longcontext', temperature: 1.0, top_p: 1.0, max_tokens: 6, },
                { 'key': 'hunyuan-standard', 'value': 'hunyuan-standard', temperature: 1.0, top_p: 1.0, max_tokens: 4, },
                { 'key': 'hunyuan-standard-256K', 'value': 'hunyuan-standard-256K', temperature: 1.0, top_p: 1.0, max_tokens: 6, },
            ],
            'prompt': '您好，我是腾讯混元大模型。我支持文学创作、文本概要、角色扮演、代码编写能力！',
        },
        {
            'key': '讯飞·星火', 'value': '星火', 'logo': 'https://juhecdn.oss-cn-hangzhou.aliyuncs.com/chat/logo-spark@2x.png',
            versions: [
                { 'key': 'Spark4.0 Ultra', 'value': '4.0Ultra', temperature: 0.5, top_p: 1, max_tokens: 8, },
                { 'key': 'Spark Max-32K', 'value': 'max-32k', temperature: 0.5, top_p: 1, max_tokens: 8, },
                { 'key': 'Spark Max', 'value': 'generalv3.5', temperature: 0.5, top_p: 1, max_tokens: 8, },
                { 'key': 'Spark Pro-128K', 'value': 'pro-128k', temperature: 0.5, top_p: 1, max_tokens: 4, },
                { 'key': 'Spark Pro', 'value': 'generalv3', temperature: 0.5, top_p: 1, max_tokens: 8, },
                { 'key': 'Spark Lite', 'value': 'lite', temperature: 0.5, top_p: 1, max_tokens: 4, },

            ],
            'prompt': '你好，我是讯飞星火。快来和我交流吧！我可以为你答疑解惑，创作文案，生成创意和代码，成为你的高效智能助手。',
        },
        {
            'key': 'Meta·Llama-3', 'value': 'Llama-3', 'logo': 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/meta-ai.png',
            versions: [
                { 'key': 'Meta-Llama-3-8B', 'value': 'Meta-Llama-3-8B', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
                { 'key': 'Meta-Llama-3-70B', 'value': 'Meta-Llama-3-70B', temperature: 0.8, top_p: 0.8, max_tokens: 2, },
            ],
            'prompt': '你好，我是Meta·Llama-3。作为你的智能伙伴，我擅长语言细微差别、上下文理解、代码生成以及翻译和对话生成等复杂任务。',
        },
    ],
    'callToolsModels': ['deepseek', 'moonshot', '通义千问', '豆包'],   // 开启调用工具的模型
}

export default CNF;